import { url, token } from '@/api/api.js'

var urlSettings = url + "/wp-json/ccm-settings/v1/";
var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var requestOptions = {
    redirect: 'follow'
};

export default {
    state: {  
        calendar: false,
        myActivePlan: [],      
        myPastPlans: [],
        countMyOrders: 0,
        bonusSettings: {},
    },
    mutations: {
        setCalendar(state, payload) {
            state.calendar = payload || false;
        },
        setMyPlans( state, payload) {  

            state.myActivePlan = payload.filter(
                (item) => (
                    item && (item.status == 'active' 
                        || item.status == 'scheduled'
                        || item.temporarily_inactive == '1' )
                    // && new Date(item.strtotime) > new Date()
                )) || [];
            
            state.myPastPlans = payload.filter(
                (item) => (
                    item && (!item.status.includes('active') && item.temporarily_inactive != '1' )
                )) || [];
        },
        setCountMyOrders(state, payload) {
            state.countMyOrders = payload || 0;
        }, 
        setCalendarDate( state, payload ) {
            let plans = state.myActivePlan;
           
            plans.map( plan => {

                if ( plan.order_id == payload.order_id ) {                                   
                    plan.delivery_date = payload.delivery_date;
                    plan.download = payload.download;
                }
            });
            
            state.myActivePlan = plans;
        },
        setOrderCansel( state, payload ) {
            let planCansel = state.myActivePlan.filter(plan => (plan.order_id == payload));
            state.myActivePlan = state.myActivePlan.filter( plan => ( plan.order_id != payload ) );
            state.myPastPlans.push( planCansel[0] );
        },
        setBonusSettings( state, payload ) {
            state.bonusSettings = payload || {};
        },
    },
    actions: {
        async getMyPlans ( {commit} ) { 
            requestOptions.method = 'GET';
            requestOptions.headers = myHeaders;

            try {
                //commit('viewLoader', true);
                //let addID = ID ? '?order=' + ID : '';
                const Data = await fetch(urlSettings + 'plans/', requestOptions );   
                             
                const data = await Data.text();                
                const dataParse = await JSON.parse(data);            
           
                commit('setMyPlans', dataParse);   
                setTimeout(() => {
                    commit('viewLoader', false);
                }, 2000);                                         
                                
                if ( dataParse.length == 0 ) {                                 
                    return;
                }
      
              
            } catch ( error ) {    
                commit( 'viewLoader', false );       
                console.log('error', error.message);
                throw error;
                
            }

        },
        async getBonusSettings({ commit }) {
            commit('viewLoader', true);
            requestOptions.method = 'GET';
            requestOptions.headers = myHeaders;

            try {
                const Data = await fetch( urlSettings + 'bonus/', requestOptions);
                const data = await Data.text();
                const dataParse = await JSON.parse( data );
               
                commit('setBonusSettings', dataParse);
                commit('viewLoader', false);

            } catch (error) {
                commit('viewLoader', false);
                console.log('error', error.message);
                throw error;

            }
        },
        async getCountMyOrders({ commit }) {
            //commit('viewLoader', true);
            requestOptions.method = 'GET';
            requestOptions.headers = myHeaders;

            try {
                const Data = await fetch( urlSettings + "plans/?data=count", requestOptions);
                const data = await Data.text();
                commit('setCountMyOrders', data );
                // commit('viewLoader', false);
            } catch (error) {

                // commit('viewLoader', false);
                console.log('error', error.message);
                throw error;

            }
        },
        async updatePlanDetails( {commit}, { ID, data } ) {
            commit('viewLoader', true);
            myHeaders.append("Authorization", "Bearer " + token);
            requestOptions.headers = myHeaders;
            requestOptions.method = 'PUT';
            requestOptions.body = JSON.stringify(data);

            try {
                const Data = await fetch( urlSettings + 'plans/' + ID, requestOptions);
                const data = await Data.text();                
                const newDate = await JSON.parse(data);
               
                commit('setCalendarDate', newDate);
                commit('viewLoader', false);
                
            } catch (error) {

                commit('viewLoader', false);
                console.log('error', error.message);
                throw error;

            }
        },
        async addBonus({ commit }, ID ) {
            commit('viewLoader', true);
            myHeaders.append("Authorization", "Bearer " + token);
            requestOptions.headers = myHeaders;
            requestOptions.method = 'PUT';

            try {
                const Data = await fetch( urlSettings + "add-bonus/" + ID, requestOptions);
                const res = await Data.text();
                console.log(res);
                commit('viewLoader', false);

            } catch (error) {
                commit('viewLoader', false);
                commit('setAlertData', { title: 'Error', text: 'The data was not saved. Please try again later', type: 'error', visible: true });
                console.log('error', error.message);
                throw error;
            }
        },
        async canсelOrder({ commit }, { data }) {
            //commit('viewLoader', true);

            myHeaders.append("Authorization", "Bearer " + token);
            requestOptions.headers = myHeaders;
            requestOptions.method = 'PUT';
            requestOptions.body = JSON.stringify( data );

            try {
                const Data = await fetch(urlSettings + "cancelled-plan/" + data.ID, requestOptions);
                const res = await Data.text();

                if (res && res != 'true' ) {
                    commit('setAlertData', { title: 'Attention!', text: res, type: 'error', visible: true });
                }

                commit('viewLoader', false);

            } catch (error) {
                commit('viewLoader', false);
                commit('setAlertData', { title: 'Error', text: 'The data was not saved. Please try again later', type: 'error', visible: true });
                console.log('error', error.message);
                throw error;
            }
           
        },
        async reactiveOrder({ commit }, { data }) {
            
            //commit('viewLoader', true);
            myHeaders.append("Authorization", "Bearer " + token);
            requestOptions.headers = myHeaders;
            requestOptions.method = 'PUT';

            try {
                const Data = await fetch(urlSettings + "reactive-plan/" + data.order_id, requestOptions);
                const res = await Data.text();

                if ( res ) {
                    commit('setAlertData', { title: 'Attention!', text: 'The plan is activated', type: 'success', visible: true });
                    setTimeout(() => {
                        location.reload();
                    }, 1);                    
                }

                
                commit('viewLoader', false);

            } catch (error) {
                commit('viewLoader', false);
                commit('setAlertData', { title: 'Error', text: 'The data was not saved. Please try again later', type: 'error', visible: true });
                console.log('error', error.message);
                throw error;
            }

        }
    },
    getters: {
        myPastPlans ( state ) {
            return state.myPastPlans;
        },
        countMyOrders(state) {
            return state.countMyOrders;
        },
        myActivePlan(state) {
            return state.myActivePlan;
        },
        calendar(state) {
            return state.calendar;
        },
        updateOrderItems(state) {
            return state.updateOrderItems;
        },
        bonusSettings(state) {
            return state.bonusSettings;
        },
    }
}
